import { createFileRoute } from '@tanstack/react-router';

import { NetworkEditorPage } from '../features/admin/networks/components/NetworkEditorPage';

export const Route = createFileRoute('/networks/edit/$networkId')({
  component: NetworkEditRoute,
});

function NetworkEditRoute() {
  const { networkId } = Route.useParams();
  return <NetworkEditorPage networkId={networkId} />;
}
